<template>
  <div class="commentEditForm">
    <div class="commentEditRow">
      <textarea
        v-model="commentText"
        :maxlength="maxlength"
        :aria-invalid="validated"
      >
      </textarea>

      <div class="comment-error" v-if="validated" role="alert">
        <span>{{ $texter.tomKommentar }}</span>
      </div>
    </div>
    <div class="commentEditRow">
      <button
        class="btn btn-primary"
        @click="updateComment()"
      >
        {{ $texter.spara }}
      </button>
      
      <button
        class="btn btn-default btn-cancel"
        @click.prevent="cancel()"
        :disabled="this.isLoading"
      >
        {{ $texter.avbryt }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "editform",
  props: {
    commentId: Number,
    editCommentText: String,
  },
  data: function () {
    return {
      commentText: this.editCommentText,
      isLoading: false,
      isValidationAllowed: false,
      maxlength: 1999,
    };
  },
  computed: {
    validated() {
      return this.isValidationAllowed && !this.commentText;
    },
  },
  methods: {
    async updateComment() {
      try {
        this.validate();
        if (!(this.isValidationAllowed && !this.commentText)) {
          this.isLoading = true;
          this.$loading(true);
          this.$commentService
            .editComment({
              CommentId: this.commentId,
              IsAdmin: this.$isAdmin,
              Text: this.commentText,
            })
            .then((res) => {
              this.$fetchData();
              this.$emit("editComment", false);
            });
        }
      } catch (err) {
        this.isError = true;
        this.isLoading = false;
        this.isValidationAllowed = false;
        this.$loading(false);
      } finally {
      }
    },
    cancel() {
      this.$emit("editComment", false);
    },
    validate() {
      this.isValidationAllowed = true;
    },
  },
};
</script>
